export enum OptionsFilterEnum {
  query = "query",
  "source.id" = "source.id",
  "salesChannelId" = "salesChannelId",
  "RUT" = "customer.id",
}
